import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type {
  LinkedDevice,
  AntivirusSlice as AntivirusSliceType,
} from './types';

const initialState: AntivirusSliceType = {
  linkedDevices: null,
};

const antivirusSlice = createAppSlice({
  name: 'antivirus',
  initialState,
  reducers: {
    setLinkedDevices(state, action: PayloadAction<LinkedDevice[]>) {
      state.linkedDevices = action.payload;
    },
  },
});

export const { setLinkedDevices } = antivirusSlice.actions;
export default antivirusSlice.reducer;
